import {Component, OnDestroy, OnInit, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
// removed legacy rxjs-compat operator import
import {PaginationInstance} from "ngx-pagination";
import {UserVerificationService} from "../services/user-verification.service";
import {KeycloakService} from "../services/keycloak.service";
import { Subscription } from 'rxjs';
import {NgForm} from "@angular/forms";
import {HttpService} from "../services/http.service";
import {ApiEndpoints} from "../services/api-endpoints";
import {StringUtils} from "../services/string-utils";
import {flatMap, map, tap} from 'rxjs/operators';

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-group-network-servers',
  templateUrl: './group-network-servers.component.html',
})
export class GroupNetworkServersComponent implements OnInit, OnDestroy {

  isAdmin: boolean = false;
  username: string = KeycloakService.username;

  listGroupNetworkServers: any[];
  canAddGroupNetworkServers: boolean;

  isAdminSubscription: Subscription;
  httpSubscription: Subscription;

  public inputKeywordGroupNetworkServerSearch = "";
  public optionGroupNetworkServerSearch = "Search Type";

  configPagerGroupNetworkServers: PaginationInstance = {
    id: 'group-network-servers-list',
    currentPage: 1,
    itemsPerPage: 5,
  };

  public groupServersRefreshing = false;

  @Input() virtId: string;
  @Output() groupNetworkServersLoadedEvent = new EventEmitter<any[]>();
  constructor(private route: ActivatedRoute,
              private router: Router,
              private http: HttpClient,
              private userVerificationService: UserVerificationService,
              private httpService: HttpService) {
    this.isAdmin = this.userVerificationService.isAdmin;
  }

  GroupNetworkServers(id) {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let options =  {headers: headers};
    var body: any = {"nsGroupId": id};
    var url = ApiEndpoints.GET_NETWORK_SERVERS_OF_NS_GROUP;
    this.http.post(url, body, options).subscribe(
        data => {
          this.listGroupNetworkServers = this.parseGroupNetworkServersList(data);
          this.groupNetworkServersLoadedEvent.emit(this.listGroupNetworkServers);
          this.groupServersRefreshing = false;
        }
      );
  }

  GroupNetworkSearch(vIdSearch, urlSearch, filterSearch, keywordSearch) {
    this.groupServersRefreshing = true;
    if (filterSearch == "Name") {
      var body: any = {"nsGroupId": vIdSearch, "name": keywordSearch};
      var url = urlSearch;
      const headers = new HttpHeaders({'Content-Type': 'application/json'});
      let options =  {headers: headers};
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listGroupNetworkServers = this.parseGroupNetworkServersList(data)
            this.groupNetworkServersLoadedEvent.emit(this.listGroupNetworkServers);
            this.groupServersRefreshing = false;
          }
        );
    }
    if (filterSearch == "NS ID") {
      var body: any = {"nsGroupId": vIdSearch, "nsId": keywordSearch};
      var url = urlSearch;
      const headers = new HttpHeaders({'Content-Type': 'application/json'});
      let options =  {headers: headers};
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listGroupNetworkServers = this.parseGroupNetworkServersList(data)
            this.groupNetworkServersLoadedEvent.emit(this.listGroupNetworkServers);
            this.groupServersRefreshing = false;
          }
        );
    }
    if(filterSearch == 'Search Type'){
      this.GroupNetworkServers(this.virtId)
    }
  }

  parseGroupNetworkServersList(listGroupNetworkServers) {
    listGroupNetworkServers.forEach(groupNetworkServer => {
      groupNetworkServer.netIds = this.insertSpacesBetweenIds(groupNetworkServer.netIds);
    });
    return listGroupNetworkServers;
  }

  insertSpacesBetweenIds(ids: Array<string>) {
    return StringUtils.insertSpacesBetweenIds(ids);
  }

  refreshGroupNetworkServers() {
    this.GroupNetworkServers(this.virtId);
  }

  onKeywordSearch(event: KeyboardEvent) {
    var urlSearch = ApiEndpoints.GET_NETWORK_SERVERS_OF_NS_GROUP;
    if (event.keyCode === 13) {
      this.GroupNetworkSearch(this.virtId, urlSearch, this.optionGroupNetworkServerSearch, this.inputKeywordGroupNetworkServerSearch);
    }
  }

  onOptionGroupNetworkServerSearchChanged(event) {
    const value = event.target.value;
    this.inputKeywordGroupNetworkServerSearch = "";
  }

  ngOnInit() {
    this.GroupNetworkServers(this.virtId);

    $('.table-filter-search').selectpicker({
      liveSearch: true,
      maxOptions: 1
    });
  }

  ngOnDestroy() {

  }

}
